import React, { useState } from "react"

import { CTA, StoryBlock, GridLines, Headline, ContentRow } from "@shared"
import { PageSection } from "@components/sections"
import { CONSTANTS, URLS } from "@data"
import { css, logTool } from "@jsUtils"
import { getSafeDataMap } from "@jsUtils/contentful"

import Styles from "./featuredinsights.module.scss"

const { COLORS, THEMES } = CONSTANTS

const log = logTool()

const FeaturedInsights = ({ data }) => {
  log("FeaturedInsights: ", { data, Styles })

  const [ready, setReady] = useState(false)

  // no iterable data means we do not display Featured Insights
  if (!data) {
    return null
  }

  const blocks = getSafeDataMap(data, article => {
    return (
      <StoryBlock
        key={article.id}
        data={article}
        color={COLORS.FLURO}
        hideDate
        hasCopy
        ready={ready}
        styles={{
          wrapper: Styles.insight
        }}
      />
    )
  })

  return (
    <PageSection
      className={css(Styles.featuredInsightWrapper, ready && Styles.ready)}
      theme={THEMES.TIN}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={THEMES.TIN} />
      <section className={Styles.leadWrapper}>
        <Headline size={2} className={Styles.lead}>
          Featured Insights
        </Headline>
        <CTA ready={ready} className={Styles.cta} color={COLORS.FLURO} to={URLS.NEWSROOM}>
          View All Insights
        </CTA>
      </section>
      {blocks.length && (
        <ContentRow gridName="quarterAuto" extraClass={Styles.rows}>
          {blocks}
        </ContentRow>
      )}
    </PageSection>
  )
}

export default FeaturedInsights
